import QsInstitutionsPage from "./pages/QsInstitutionsPage";

/**
 * The QSRBN register of institutions teaching Quantity Surveying.
 *
 * On `qs.institution.access` rather than the admin role: the register
 * carries Heads of Department and their contact details, and linking one to
 * a member grants a portal role, so who may open it is granted by name.
 *
 * Editing (`qs.institution.manage`) and HOD linking (`qs.institution.hod`)
 * are separate privileges the API enforces at the buttons — a route guard
 * cannot express "may read this page but not press that".
 */
export const qsInstitutionRoutes = [
  {
    path: "/admin/qs-institutions",
    element: <QsInstitutionsPage />,
    perms: ["qs.institution.access"],
  },
];
